import React from 'react';
import { withRouter } from 'react-router-dom';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import EditBikeForm from '../../components/Bike/EditBikeForm';
import withAuthorization from '../../hoc/withAuthorization';

const EditBikePage = props =>
    <LargePaper>
        <h1 style={stylesDefault.title}>Modification d'un vélo</h1>
        <EditBikeForm history={props.history} match={props.match}/>
    </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(EditBikePage));



// WEBPACK FOOTER //
// ./src/containers/BikesPage/EditBikePage.jsx